/**
 * @description Base controller for two separate portal controllers
 * @example
 * // Inside child controller
 * var baseCtrl = $controller('BaseVulnSummaryCtrl', {$scope: $scope});
 */
;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .controller('BaseVulnSummaryCtrl', BaseVulnSummaryCtrl)

  function BaseVulnSummaryCtrl(
    $scope,
    $routeParams,
    $sce,
    traceCommonRenderService
  ) {
    'ngInject'

    var _traceUuid

    this.$onInit = function () {
      angular.extend($scope, {
        selectPropertyRow: selectPropertyRow,
        toTrusted: toTrusted,
        getTraceUuid: getTraceUuid
      })

      init()
    }

    function init() {
      _traceUuid = $routeParams.uuid
    }

    function selectPropertyRow(index) {
      traceCommonRenderService.selectProperty($scope, index)
    }

    function toTrusted(htmlCode) {
      return $sce.trustAsHtml(htmlCode)
    }

    function getTraceUuid() {
      return _traceUuid
    }
  }
})()
